const event = {
  not_found: 6100,
  max_members_exceeded: 6101,
};

export default event;
